/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FaxHistory
 */
export interface FaxHistory {
    /**
     * 
     * @type {number}
     * @memberof FaxHistory
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof FaxHistory
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof FaxHistory
     */
    details?: string;
}

/**
 * Check if a given object implements the FaxHistory interface.
 */
export function instanceOfFaxHistory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FaxHistoryFromJSON(json: any): FaxHistory {
    return FaxHistoryFromJSONTyped(json, false);
}

export function FaxHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : json['date'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'details': !exists(json, 'details') ? undefined : json['details'],
    };
}

export function FaxHistoryToJSON(value?: FaxHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'status': value.status,
        'details': value.details,
    };
}

